// extracted by mini-css-extract-plugin
export default {"checkbox":"RoundedCheckbox_checkbox__r2f68"};